<template>
<v-row>
    <!-- Search Field -->
    <v-col cols="3">
        <v-text-field outlined dense :label="i18n['search']" :class="`${arabic ? 'arFont' : 'enFont'}`" v-model="inputSearch" @keydown.enter="applyFilters"></v-text-field>
    </v-col>
    <!-- From Date Picker -->
    <v-col cols="3">
        <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="fromDate" :label="i18n['from_date']" prepend-icon="mdi-calendar" readonly :loading="loading" outlined  dense :disabled="loading" :class="`${arabic ? 'arFont' : 'enFont'}`" clearable v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" @input="menu1 = false"></v-date-picker>
        </v-menu>
    </v-col>
    <!-- To Date Picker -->
    <v-col cols="3" class="text-center">
        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="toDate" :label="i18n['to_date']" prepend-icon="mdi-calendar" readonly :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`"  outlined :disabled="loading" dense clearable v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="toDate" @input="menu2 = false"></v-date-picker>
        </v-menu>
    </v-col>
    
    <!-- Apply Filters Button -->
   <v-col cols="3">
    <v-btn small color="success" type="submit" @click="applyFilters" :class="{'arFont': arabic, 'enFont': !arabic}">
        {{ i18n['search'] }}
    </v-btn>
   </v-col>
</v-row>

</template>

  
<script>

export default {
    
    props:['loading'],

    data() {
        return {
            menu1: false,
            menu2: false,
            fromDate: '',
            toDate: '',
            inputSearch: '' // Added to store the search input
        };
    },
    methods: {
        applyFilters() {
            this.$emit('filter-applied', {
                fromDate: this.fromDate,
                toDate: this.toDate,
                inputSearch: this.inputSearch
            });
        }
    },
    computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
};
</script>
